import React, { useState, useEffect } from "react";
import BasicInfoFields from "../BasicInfo/BasicInfoFields";
import Form from "../../../../Forms/Form";
import { Spinner } from "@fluentui/react";

const BasicInfoStep = ({ disabled, model, isNew }) => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({});

  useEffect(() => {
      if (!model) return;
      const match = model.categories?.find((option) => option.key === model.journalCategoryId);
      if (match) setSelectedCategory(match);
      setCategories(model.categories);
  }, [model]);

  if (categories?.length === 0 || (!isNew && !selectedCategory)) {
      return <Spinner className="absolute-center" text="Loading Basic Info..." />;
  }

  return (
    <Form>
      <BasicInfoFields 
        disabled={disabled} 
        model={model} 
        categories={categories} 
        selectedCategory={selectedCategory} 
        isNew={isNew} 
      />
    </Form>
  );
}
 
export default BasicInfoStep;
